<!-- <script>
/* eslint-disable */
</script> -->
<!-- <link rel="stylesheet" href="https://unpkg.com/element-ui/lib/theme-chalk/index.css"/> -->
<template>
    <div style="margin: 20px; font-size: 7px; touch-action: pan-y !important">
        <!--表单-->

        <el-form :model="formData" :rules="formRules" ref="dataForm">
            <el-form-item label="姓名" prop="name">
                <el-input
                    v-model="formData.name"
                    auto-complete="off"
                    placeholder="请输入姓名"
                    clearable
                    style="width: 80%"
                >
                </el-input>
            </el-form-item>
            <el-form-item label="日期" prop="date" hidden>
                <el-input
                    v-model="formData.date"
                    auto-complete="off"
                    placeholder="请输入日期"
                    clearable
                    style="width: 80%"
                >
                </el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
                <el-input
                    v-model="formData.email"
                    auto-complete="off"
                    placeholder="请输入邮箱"
                    clearable
                    style="width: 80%"
                >
                </el-input>
            </el-form-item>
            <el-form-item label="电话" prop="phone">
                <el-input
                    v-model="formData.phone"
                    auto-complete="off"
                    placeholder="请输入手机号"
                    clearable
                    style="width: 80%"
                >
                </el-input>
            </el-form-item>
            <el-select
                label="证件类型"
                v-model="formData.IDType"
                prop="IDTypeName"
                style="width: 80%"
            >
                <el-option value="1" label="大陆身份证">大陆身份证</el-option>
                <el-option value="2" label="大陆护照">大陆护照</el-option>
                <el-option value="3" label="驾照">驾照1</el-option>
                <el-option value="4" label="港澳通行证">港澳通行证</el-option>
                <el-option value="5" label="香港身份证">香港身份证</el-option>
                <el-option value="6" label="香港护照">香港护照</el-option>
                <el-option value="7" label="其他国家地区护照"
                    >其他国家地区护照</el-option
                >
                <el-option value="8" label="其他证件">其他证件</el-option>
            </el-select>
            <el-form-item label="证件编号" prop="IDNumber">
                <el-input
                    v-model="formData.IDNumber"
                    auto-complete="off"
                    placeholder="请输入证件编号"
                    clearable
                    style="width: 70%"
                ></el-input>
            </el-form-item>
            <el-form-item label="职业" prop="occupation">
                <el-radio-group v-model="formData.occupation">
                    <el-radio :label="1"
                        >自僱人士<br />Self-employed<br /><br
                    /></el-radio>
                    <el-radio :label="2"
                        >專業、技術及相關範疇<br />Professional, technical and
                        related discipline<br /><br />
                    </el-radio>
                    <el-radio :label="3"
                        >退休<br />Retired<br /><br
                    /></el-radio>
                    <el-radio :label="4">其他<br />Others<br /><br /></el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="具体行业" prop="industry">
                <el-input
                    v-model="formData.industry"
                    auto-complete="off"
                    placeholder="请注明具体行业"
                    clearable
                    style="width: 70%"
                ></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <!-- <el-button @click.native="hideForm">取消</el-button> -->
            <el-button type="primary" @click.native="formSubmit()"
                >提交</el-button
            >
            <!-- <router-link to='/risk/risk_question?orderNum=1' > -->
            <router-link
                :to="{
                    path: '/public/riskQuestion',
                    query: {
                        orderNum: 1,
                        investorId: parseInt(this.query.investorId),
                    },
                }"
                @click.native="Answer()"
            >
                <el-button type="primary">开始答题</el-button>
            </router-link>
        </div>
    </div>
</template>

<script>
import { publicInvestorSaveOrEdit } from "../../api/public/riskInvestor";
//import Upload from "../../components/File/Upload.vue";
//import { Message } from "element-ui";
//import store from "../../store/index";

// let addData = {
//     investorId: "",
//     name: "",
//     email: "",
//     phone: "",
//     IDTypeName: "",
//     IDNumber: "",
// };
const formJson = {
    investorId: "",
    name: "张三",
    email: "zhangsan@test.com",
    phone: "13933336666",
    IDType: 1,
    IDNumber: "310001190801010002",
    occupation: 1,
    industry: "服务业",
};
export default {
    data() {
        return {
            query: {
                investorId: 1888,
                title: "",
                page: 1,
                limit: 20,
            },
            list: [],
            total: 0,
            loading: true,
            index: null,
            formName: "add",
            formMap: {
                add: "新增",
                edit: "编辑",
            },
            formLoading: false,
            //formVisible: true,
            formData: formJson,
            deleteLoading: false,
            investorId: 2888,
        };
    },
    components: {
        //Upload
    },
    methods: {
        Answer() {
            this.$route.go(0);
        },
        // onReset() {
        //     this.$router.push({
        //         path: ""
        //     });
        //     this.query = {
        //         title: "",
        //         page: 1,
        //         limit: 20
        //     };
        //     this.getList();
        // },

        // 刷新表单
        resetForm() {
            if (this.$refs["dataForm"]) {
                // 清空字段
                this.$refs["dataForm"].resetFields();
                // 清空验证信息表单
                this.$refs["dataForm"].clearValidate();
            }
        },
        // 隐藏表单
        // hideForm() {
        //     // 更改值
        //     this.formVisible = !this.formVisible;
        //     return true;
        // },
        // 显示表单
        // handleForm(index, row) {
        //     this.formVisible = true;
        //     // 刷新表单
        //     this.resetForm();
        //     this.formData = JSON.parse(JSON.stringify(formJson));
        //     if (row !== null) {
        //         this.formData = Object.assign({}, row);
        //     }
        //     this.formName = "add";
        //     if (index !== null) {
        //         this.index = index;
        //         this.formName = "edit";
        //     }
        // },
        formSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    //this.formLoading = true;
                    let data = Object.assign({}, this.formData);
                    //addData = Object.assign({}, this.formData);
                    publicInvestorSaveOrEdit(data, this.formName)
                        .then((response) => {
                            //this.formLoading = false;
                            //this.$message.success(response.message);
                            //console.log(response.code);
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }
                            this.$message.success("操作成功");
                            //this.formVisible = false;
                            //var res_investorId = Object.assign({}, response.data.investorId);
                            this.query.investorId = response.data.investorId;
                            this.$message.success(
                                "investorId   ### @@" + response.data.investorId
                            );

                            // if (this.formName === "add") {
                            //     // 向头部添加数据
                            //     addData.investorId = response.data.investorId;
                            //     this.$message.success("investorId=== " + response.data.investorId);
                            //     //store.getters.investorId = data.investorId;
                            //     this.query.investorId=data.investorId;

                            //     // this.$route.push(
                            //     //     {   path:'/risk/risk_question',
                            //     //         query: {
                            //     //                 orderNum:1,
                            //     //                 investorId:199
                            //     //                 }
                            //     //     }
                            //     //     );
                            //     this.list.unshift(data);
                            // } else {
                            //     this.list.splice(this.index, 1, data);
                            // }
                        })
                        .catch(() => {
                            //this.formLoading = false;
                        });
                }
            });
        },
    },
    filters: {
        statusFilterType(status) {
            const statusMap = {
                0: "gray",
                1: "success",
            };
            return statusMap[status];
        },
        statusFilterName(status) {
            const statusMap = {
                0: "禁用",
                1: "正常",
            };
            return statusMap[status];
        },
    },
    mounted() {},
    created() {
        // 将参数拷贝进查询对象
        let query = this.$route.query;
        this.query = Object.assign(this.query, query);
        this.query.limit = parseInt(this.query.limit);
        // 加载表格数据
        //this.getList();
    },
};
</script>

<style type="text/scss" lang="scss"></style>
